function Contact() {
  return (
    <>
      <div id="contact" className="flex flex-col my-5 box-border px-8 pt-12 pb-20 text-white">
        <div className="text-center">
          <h1 className="m-0 text-xl font-bold mb-5">Contact Me</h1>
        </div>
        <div className="flex flex-col gap-30">
          <div className="flex md:flex-row sm:flex-col items-center justify-evenly lg:mb-10 sm:mb-0">
            <a href="https://www.linkedin.com/in/aqil-shahzad-82b942238?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noopener noreferrer">
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                <img src="linkedin.png" alt="LinkedIn" />
                <h3>LinkedIn</h3>
              </div>
            </a>
            <a href="https://github.com/Aqil-Shahzad" target="_blank" rel="noopener noreferrer">
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                <img src="github.png" alt="GitHub" />
                <h3>GitHub</h3>
              </div>
            </a>
          </div>
          <div className="flex md:flex-row sm:flex-col justify-evenly items-center">
            <a href="mailto:aqilshahzadbhatti@gmail.com" target="_blank" rel="noopener noreferrer">
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                <img src="Email.png" alt="Email" />
                <h3>Email</h3>
              </div>
            </a>
            <a href="https://api.whatsapp.com/send?phone=03063146704" target="_blank" rel="noopener noreferrer">
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                <img src="whatsapp.png" alt="WhatsApp" />
                <h3>WhatsApp</h3>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
export default Contact;
